var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageBanner3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.23 432.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #01a0e2;\n        stroke-width: .5px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: #263238;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #fafafa;\n      }\n\n      .cls-7 {\n        fill: #f5f5f5;\n      }\n\n      .cls-8 {\n        fill: #455a64;\n      }\n\n      .cls-9 {\n        fill: #e0e0e0;\n      }\n\n      .cls-10 {\n        fill: #ff725e;\n      }\n\n      .cls-3 {\n        stroke: #000;\n      }\n\n      .cls-11 {\n        fill: #eb996e;\n      }\n\n      .cls-12 {\n        fill: #ffbe9d;\n      }\n\n      .cls-13 {\n        opacity: .6;\n      }\n\n      .cls-13, .cls-14, .cls-15 {\n        fill: none;\n      }\n\n      .cls-16 {\n        fill: #ebebeb;\n      }\n\n      .cls-14 {\n        opacity: .2;\n      }\n\n      .cls-15 {\n        opacity: .3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 285.27,
    y: 315.99,
    width: 8.14,
    height: 97.49,
    transform: "translate(578.67 729.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m231.76,320.4h116.38c0-6.98-5.66-12.63-12.63-12.63h-91.12c-6.98,0-12.63,5.66-12.63,12.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m348.61,320.87h-117.32v-.47c0-7.22,5.88-13.1,13.1-13.1h91.12c7.22,0,13.1,5.88,13.1,13.1v.47Zm-116.37-.94h115.42c-.25-6.49-5.6-11.69-12.15-11.69h-91.12c-6.55,0-11.9,5.2-12.15,11.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m281.43,320.65c0,.17,3.2.3,7.14.3s7.14-.13,7.14-.3-3.2-.3-7.14-.3-7.14.13-7.14.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m253.74,422.32h1.15c0-19.09,15.53-34.62,34.62-34.62s34.62,15.53,34.62,34.62h1.15c0-19.73-16.05-35.78-35.77-35.78s-35.77,16.05-35.77,35.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m319.35,424.09c0,2.96,2.4,5.36,5.36,5.36s5.36-2.4,5.36-5.36-2.4-5.36-5.36-5.36-5.36,2.4-5.36,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m248.68,423.35c0,2.96,2.4,5.36,5.36,5.36s5.36-2.4,5.36-5.36-2.4-5.36-5.36-5.36-5.36,2.4-5.36,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m254.09,413.48c0,.17,15.57.3,34.77.3s34.77-.13,34.77-.3-15.56-.3-34.77-.3-34.77.13-34.77.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m351.56,219.47v71.77c0,9.41-7.63,17.04-17.04,17.04h-55.3l7.51-88.81c0-4.19,3.4-7.6,7.6-7.6h49.64c4.19,0,7.6,3.4,7.6,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m332.01,307.77s.04-.08.13-.21c.11-.16.24-.35.41-.59.37-.51.89-1.27,1.52-2.28,1.25-2.02,2.91-5.07,4.12-9.14.61-2.03,1.11-4.31,1.37-6.79.29-2.47.22-5.15.22-7.97,0-5.64-.01-11.84-.02-18.34.03-12.99.06-24.75.08-33.33.04-4.22.07-7.66.09-10.1.02-1.15.04-2.07.05-2.75.02-.63.04-.96.06-.96s.04.33.06.96c.01.68.03,1.59.05,2.75.02,2.44.05,5.88.09,10.1.02,8.58.05,20.34.08,33.33,0,6.5-.02,12.7-.02,18.34-.01,2.81.04,5.51-.27,8.02-.28,2.51-.82,4.81-1.46,6.85-1.28,4.1-3.01,7.15-4.32,9.14-.66,1-1.22,1.74-1.62,2.23-.39.49-.61.74-.63.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m301.9,307.81s.63-.07,1.76-.1c1.23-.01,2.85-.03,4.79-.06,4.05-.02,9.64-.02,15.81.03,3.09.03,6.03.03,8.7.1,2.67.05,5.12.19,7.1.77,1.99.55,3.41,1.49,4.27,2.24.44.37.74.69.93.93.2.23.29.35.28.37-.05.05-.45-.44-1.35-1.12-.88-.68-2.29-1.53-4.23-2.02-1.93-.51-4.33-.62-7-.64-2.69-.02-5.62-.04-8.7-.06-6.17-.04-11.76-.12-15.8-.2-1.94-.05-3.56-.09-4.79-.13-1.13-.04-1.76-.09-1.76-.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.81,
    y: 266.88,
    width: 309.51,
    height: 10.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "120.1 276.44 89.49 429.5 94.66 429.5 130.91 277.78 120.1 276.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "377.78 276.12 408.38 429.5 403.2 429.5 366.96 277.78 377.78 276.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m164.5,233.24v18.98h-3.17v2.06h3.17v12.7h59.24v-11.56h-4.39v-2.52h4.39v-3.78h1.95v-1.72h-2.32v-14.18h-58.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "208.01 233.3 208.01 266.78 223.74 266.78 223.74 255.22 219.35 255.22 219.35 252.91 223.74 252.99 223.74 249.21 225.73 249.22 225.69 247.27 223.38 247.21 223.38 233.24 208.01 233.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m209.13,254.01c0,.12-10.72.21-23.94.21s-23.94-.09-23.94-.21,10.72-.21,23.94-.21,23.94.09,23.94.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m209.13,252.09c0,.12-10.72.21-23.94.21s-23.94-.09-23.94-.21,10.72-.21,23.94-.21,23.94.09,23.94.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m212.21,246.9c0,.12-10.72.21-23.94.21s-23.94-.09-23.94-.21,10.72-.21,23.94-.21,23.94.09,23.94.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m212.5,261.04c0,.12-10.72.21-23.94.21s-23.94-.09-23.94-.21,10.72-.21,23.94-.21,23.94.09,23.94.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.26,
    y: 0.26,
    width: 98.84,
    height: 88.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m99.11,88.7s-.02-.57-.03-1.64c0-1.09-.01-2.67-.03-4.74-.01-4.15-.03-10.22-.06-17.95-.03-15.45-.07-37.53-.12-64.1l.22.22c-28.47.01-62.44.03-98.83.04h0l.26-.26c-.01,32.17-.02,62.45-.03,88.43l-.23-.23c29.49.05,54.17.09,71.49.12,8.67.03,15.49.05,20.16.06,2.33.01,4.12.02,5.34.03.6,0,1.06.01,1.38.01.31,0,.47.01.47.01,0,0-.15,0-.45.01-.32,0-.76,0-1.35.01-1.21,0-2.98.02-5.29.03-4.66.01-11.47.04-20.11.06-17.36.03-42.09.07-71.64.12H.03s0-.23,0-.23C.02,62.71.01,32.44,0,.26v-.26h.27c36.4.01,70.37.03,98.83.04h.22v.22c-.05,26.63-.09,48.76-.12,64.24-.02,7.71-.04,13.76-.06,17.9-.01,2.05-.02,3.62-.03,4.7,0,1.06-.02,1.59-.02,1.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m38.16,15.98c0,.15-5.2.26-11.62.26s-11.62-.12-11.62-.26,5.2-.26,11.62-.26,11.62.12,11.62.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m80.05,22.62c0,.15-14.29.26-31.92.26s-31.92-.12-31.92-.26,14.29-.26,31.92-.26,31.92.12,31.92.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 15.1,
    y: 33.86,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 25.35,
    y: 33.86,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.79,
    y: 33.67,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 45.85,
    y: 33.86,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.1,
    y: 33.86,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 66.35,
    y: 33.86,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 76.6,
    y: 33.86,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 15.1,
    y: 42.72,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 25.35,
    y: 42.72,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 35.6,
    y: 42.72,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 45.85,
    y: 42.72,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.1,
    y: 42.72,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 66.54,
    y: 42.53,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 76.6,
    y: 42.72,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 15.1,
    y: 51.57,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 25.53,
    y: 51.38,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.6,
    y: 51.57,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 45.85,
    y: 51.57,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.1,
    y: 51.57,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 66.35,
    y: 51.57,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 76.6,
    y: 51.57,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 15.1,
    y: 60.42,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 25.35,
    y: 60.42,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.6,
    y: 60.42,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 46.04,
    y: 60.23,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.1,
    y: 60.42,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 66.35,
    y: 60.42,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 76.6,
    y: 60.42,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 15.1,
    y: 69.28,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 25.35,
    y: 69.28,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.6,
    y: 69.28,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 45.85,
    y: 69.28,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56.1,
    y: 69.28,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 66.54,
    y: 69.09,
    width: 4.16,
    height: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 76.6,
    y: 69.28,
    width: 4.16,
    height: 4.16
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m426.23,429.5c0,.14-91.52.26-204.38.26s-204.4-.12-204.4-.26,91.5-.26,204.4-.26,204.38.12,204.38.26Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Chart_",
    "data-name": "Chart "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 165.95,
    y: 79.67,
    width: 163.91,
    height: 124.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m329.87,203.82s-.02-.78-.02-2.28c0-1.5-.01-3.71-.02-6.6-.01-5.79-.03-14.27-.05-25.1-.03-21.64-.06-52.65-.11-90.17l.21.21c-46.36.01-102.92.03-163.9.05h-.01l.26-.26c0,44.66-.02,86.95-.03,124.15l-.23-.23c48.56.05,89.51.09,118.33.12,14.42.03,25.8.05,33.59.06,3.89.01,6.88.02,8.91.03,1.01,0,1.77.01,2.3.01.52,0,.79.01.79.01,0,0-.25,0-.76.01-.52,0-1.28,0-2.27.01-2.02,0-4.99.02-8.86.03-7.78.01-19.14.04-33.54.06-28.85.03-69.86.07-118.48.12h-.23s0-.23,0-.23c0-37.2-.02-79.49-.03-124.15v-.26s.26,0,.26,0h.01c60.98.02,117.54.03,163.9.05h.21v.21c-.05,37.58-.08,68.63-.11,90.31-.02,10.81-.04,19.28-.05,25.05-.01,2.87-.02,5.07-.02,6.56,0,1.48-.02,2.23-.02,2.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 214.31,
    y: 137.83,
    width: 11.07,
    height: 29.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 261.28,
    y: 137.83,
    width: 11.07,
    height: 29.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 276.94,
    y: 120.25,
    width: 11.07,
    height: 47.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.99,
    y: 158.34,
    width: 11.07,
    height: 10.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 229.97,
    y: 151.35,
    width: 11.07,
    height: 16.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 245.63,
    y: 147.58,
    width: 11.07,
    height: 20.19
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 208.07,
    cy: 126.47,
    r: 2.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.77,85.79c.14,0,.26,10.93.26,24.41s-.12,24.41-.26,24.41-.26-10.93-.26-24.41.12-24.41.26-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m318.31,103.62s-.61.07-1.73.1c-1.2.02-2.79.05-4.71.08-3.98.05-9.47.08-15.53.08-3.03,0-5.91-.01-8.55-.02-.66,0-1.3-.05-1.87.06-.58.1-1.11.34-1.57.66-.91.64-1.46,1.61-1.63,2.54-.1.46-.07.93-.08,1.38,0,.44-.01.87-.02,1.26-.02.77-.03,1.44-.04,2.03-.03,1.11-.07,1.73-.1,1.73s-.07-.61-.1-1.73c-.01-.58-.03-1.26-.04-2.03,0-.4-.01-.82-.02-1.26,0-.44-.04-.93.05-1.45.16-1.02.75-2.1,1.75-2.82.5-.36,1.09-.64,1.73-.76.66-.13,1.31-.08,1.96-.09,2.64,0,5.52-.01,8.55-.02,6.07,0,11.56.03,15.53.08,1.92.03,3.51.06,4.71.08,1.11.03,1.73.07,1.73.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m296.43,117.97s-.1-.02-.27-.08c-.2-.07-.46-.16-.77-.27-.34-.12-.75-.29-1.26-.44-.51-.15-1.09-.31-1.75-.5-2.63-.7-6.6-1.29-11.46-.81-4.82.54-10.58,2.24-15.76,6.1-2.6,1.9-4.87,4.43-7.26,7.02-2.4,2.55-4.99,5.31-8.49,6.9-1.74.77-3.63,1.19-5.49,1.14-1.86-.04-3.65-.5-5.32-1.13-3.34-1.28-6.16-3.29-8.85-5.06-2.71-1.76-5.37-3.31-8.04-4.34-2.66-1.07-5.34-1.41-7.77-1.24-4.87.29-8.64,1.8-11.02,3.1-1.2.65-2.07,1.25-2.66,1.68-.27.2-.48.36-.65.49-.15.11-.23.16-.23.15,0,0,1.06-1.13,3.45-2.5,2.37-1.36,6.15-2.95,11.1-3.29,2.46-.19,5.23.14,7.94,1.21,2.72,1.03,5.42,2.58,8.15,4.34,2.72,1.77,5.5,3.74,8.78,4.98,1.63.61,3.36,1.04,5.15,1.08,1.78.04,3.59-.35,5.26-1.1,3.37-1.53,5.93-4.23,8.33-6.77,2.39-2.58,4.69-5.14,7.35-7.06,5.28-3.9,11.13-5.58,16-6.08,4.92-.44,8.92.22,11.55.98.65.2,1.23.39,1.74.55.5.17.91.36,1.24.49.31.13.56.24.76.32.17.07.25.12.25.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 244.77,
    cy: 136.24,
    r: 2.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 282.76,
    cy: 115.52,
    r: 2.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.06,172.35c0,.14-2.5.26-5.59.26s-5.59-.12-5.59-.26,2.5-.26,5.59-.26,5.59.12,5.59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.58,172.35c0,.14-2.5.26-5.59.26s-5.59-.12-5.59-.26,2.5-.26,5.59-.26,5.59.12,5.59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m241.78,172.35c0,.14-2.5.26-5.59.26s-5.59-.12-5.59-.26,2.5-.26,5.59-.26,5.59.12,5.59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m257.22,172.35c0,.14-2.5.26-5.59.26s-5.59-.12-5.59-.26,2.5-.26,5.59-.26,5.59.12,5.59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m272.27,172.35c0,.14-2.5.26-5.59.26s-5.59-.12-5.59-.26,2.5-.26,5.59-.26,5.59.12,5.59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m287.33,172.35c0,.14-2.5.26-5.59.26s-5.59-.12-5.59-.26,2.5-.26,5.59-.26,5.59.12,5.59.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m200.96,181.78h-1.55v-.91h4.22v.91h-1.55v3.93h-1.12v-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.32,185.71l-.93-1.35h-1.03v1.35h-1.12v-4.84h2.09c1.29,0,2.1.67,2.1,1.76,0,.73-.37,1.26-1,1.53l1.09,1.56h-1.2Zm-1.05-3.93h-.91v1.69h.91c.68,0,1.03-.32,1.03-.84s-.35-.84-1.03-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.07,184.81v.9h-3.75v-4.84h3.66v.9h-2.54v1.05h2.25v.87h-2.25v1.12h2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m218.4,180.87v4.84h-.92l-2.41-2.94v2.94h-1.11v-4.84h.93l2.41,2.94v-2.94h1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m219.55,180.87h2.2c1.58,0,2.67.95,2.67,2.42s-1.08,2.42-2.67,2.42h-2.2v-4.84Zm2.14,3.92c.96,0,1.59-.57,1.59-1.5s-.63-1.5-1.59-1.5h-1.02v3h1.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m206.29,125.94s-.19.04-.55.05c-.42.01-.94.03-1.58.05-1.45.02-3.41.05-5.81.08-2.48.02-5.39.03-8.62.06-1.62,0-3.33.01-5.09.02-.87,0-1.79.05-2.73-.12-.93-.16-1.84-.48-2.68-.96-1.69-.96-2.94-2.52-3.55-4.24-.3-.86-.48-1.75-.48-2.63,0-.85,0-1.68,0-2.49.02-3.23.04-6.14.06-8.62.03-2.4.06-4.36.08-5.81.02-.64.04-1.16.05-1.58.02-.36.03-.55.05-.55s.04.19.05.55c.01.42.03.94.05,1.58.02,1.45.05,3.41.08,5.81.02,2.48.03,5.39.06,8.62.04,1.63-.16,3.35.48,4.95.57,1.61,1.75,3.07,3.33,3.96.78.45,1.64.75,2.51.9.86.16,1.75.11,2.64.12,1.76,0,3.46.01,5.09.02,3.23.02,6.14.04,8.62.06,2.4.03,4.36.06,5.81.08.64.02,1.16.04,1.58.05.36.02.55.03.55.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "317.69 83.39 317.69 157.08 326.6 157.08 338.88 157.08 396.1 157.08 396.1 83.39 317.69 83.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m317.69,83.39s.11,0,.35-.01c.25,0,.61,0,1.07-.01.96,0,2.36-.02,4.19-.03,3.69-.01,9.08-.03,15.93-.06,13.77-.03,33.39-.07,56.88-.12h.23s0,.23,0,.23c0,21.55.02,46.8.03,73.68h0v.27h-.26c-28.81-.01-55.74-.03-78.41-.04h-.22s0-.22,0-.22c.05-22.17.09-40.61.11-53.52.02-6.42.04-11.47.06-14.92.01-1.7.02-3.01.03-3.91,0-.88.02-1.33.02-1.33,0,0,.02.48.02,1.37,0,.91.01,2.23.03,3.96.01,3.47.03,8.53.06,14.97.03,12.88.07,31.28.11,53.38l-.22-.22c22.67-.01,49.6-.02,78.41-.04l-.26.26h0c.01-26.89.02-52.14.03-73.69l.23.23c-23.42-.05-43-.09-56.73-.12-6.87-.03-12.27-.05-15.98-.06-1.84-.01-3.26-.02-4.23-.03-.47,0-.83,0-1.09-.01-.25,0-.38-.01-.38-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m356.54,91.74c-13.36,0-24.19,10.83-24.19,24.19s10.83,24.19,24.19,24.19,24.19-10.83,24.19-24.19-10.83-24.19-24.19-24.19Zm.36,38.69c-8.21,0-14.86-6.65-14.86-14.86s6.65-14.86,14.86-14.86,14.86,6.65,14.86,14.86-6.65,14.86-14.86,14.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m342.05,115.57c0-6.05,3.62-11.26,8.81-13.57l-3.72-8.36c-8.69,3.67-14.78,12.27-14.78,22.3,0,.34.01.68.03,1.02h9.74c-.04-.45-.07-.91-.07-1.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m376.56,146.23c0,.13-8.96.23-20.02.23s-20.02-.1-20.02-.23,8.96-.23,20.02-.23,20.02.1,20.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m367.65,149.91c0,.13-4.97.23-11.1.23s-11.1-.1-11.1-.23,4.97-.23,11.1-.23,11.1.1,11.1.23Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m354.8,112.44v.99l-1.97,4.59h-1.72l1.88-4.33h-1.47v.86h-1.35v-2.11h4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m359.55,116.22c0,1-.75,1.9-2.43,1.9-.77,0-1.59-.19-2.16-.55l.57-1.19c.45.3,1.01.46,1.55.46s.89-.21.89-.59c0-.34-.23-.57-1.08-.57h-1.51l.28-3.26h3.55v1.22h-2.25l-.07.81h.37c1.65,0,2.29.76,2.29,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m359.82,113.91c0-.96.61-1.55,1.43-1.55s1.43.58,1.43,1.55-.61,1.55-1.43,1.55-1.43-.57-1.43-1.55Zm4.72-1.47h1.15l-3.81,5.58h-1.15l3.81-5.58Zm-2.83,1.47c0-.57-.2-.79-.47-.79-.25,0-.47.22-.47.79s.21.79.47.79c.27,0,.47-.22.47-.79Zm2.04,2.63c0-.96.6-1.54,1.43-1.54s1.43.58,1.43,1.54-.61,1.55-1.43,1.55-1.43-.57-1.43-1.55Zm1.9,0c0-.57-.21-.79-.47-.79s-.47.22-.47.79.21.79.47.79.47-.22.47-.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "218.96 2.14 218.96 85.53 229.05 85.53 242.94 85.53 307.69 85.53 307.69 2.14 218.96 2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m218.96,2.14s.13,0,.4-.01c.28,0,.68,0,1.21-.01,1.09,0,2.67-.01,4.74-.03,4.18-.01,10.28-.03,18.03-.06,15.58-.03,37.78-.07,64.35-.12h.23s0,.23,0,.23c0,24.38.02,52.96.03,83.38h0v.27h-.26c-32.6-.01-63.08-.03-88.73-.04h-.22s0-.22,0-.22c.05-25.08.09-45.95.11-60.56.02-7.27.04-12.98.06-16.89.01-1.93.02-3.42.03-4.43,0-1,.02-1.5.02-1.5,0,0,.02.54.02,1.55,0,1.03.01,2.52.03,4.48.01,3.92.03,9.65.06,16.94.03,14.58.07,35.39.11,60.42l-.22-.22c25.65-.01,56.13-.02,88.73-.04l-.26.26h0c.01-30.43.02-59.01.03-83.39l.23.23c-26.51-.05-48.67-.09-64.21-.12-7.77-.03-13.89-.05-18.08-.06-2.08-.01-3.69-.02-4.78-.03-.53,0-.94,0-1.23-.01-.28,0-.43-.01-.43-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m262.93,11.59c-15.12,0-27.38,12.26-27.38,27.38s12.26,27.38,27.38,27.38,27.38-12.26,27.38-27.38-12.26-27.38-27.38-27.38Zm.41,43.78c-9.29,0-16.82-7.53-16.82-16.82s7.53-16.82,16.82-16.82,16.82,7.53,16.82,16.82-7.53,16.82-16.82,16.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m263.35,11.6c0,2.91,0,6.84,0,10.14,9.29,0,16.81,7.53,16.81,16.82,0,1.78-.28,3.49-.79,5.1l9.92,2.69c.66-2.35,1.01-4.82,1.01-7.38,0-14.98-12.03-27.14-26.96-27.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m246.53,38.56c0-6.85,4.1-12.74,9.97-15.36l-4.21-9.46c-9.83,4.15-16.73,13.89-16.73,25.23,0,.39.01.77.03,1.15h11.02c-.05-.51-.07-1.04-.07-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m263.34,55.38c-1.22,0-2.41-.13-3.56-.38-.42,2.44-1.22,7.17-1.85,10.89,1.62.3,3.29.46,4.99.46,12.56,0,23.14-8.46,26.36-20l-9.92-2.69c-2.16,6.79-8.52,11.72-16.03,11.72Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m285.58,73.26c0,.14-10.14.26-22.65.26s-22.66-.12-22.66-.26,10.14-.26,22.66-.26,22.65.12,22.65.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m275.5,77.42c0,.14-5.63.26-12.56.26s-12.57-.12-12.57-.26,5.62-.26,12.57-.26,12.56.12,12.56.26Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m261.06,39.41c0,.95-.75,1.86-2.43,1.86-.77,0-1.59-.19-2.17-.55l.57-1.19c.45.3,1.02.46,1.54.46s.88-.21.88-.58c0-.33-.25-.54-.85-.54h-.66v-1l1-1.08h-2.2v-1.22h4.03v.99l-1.16,1.24c.94.2,1.43.8,1.43,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m265.86,39.36c0,1-.75,1.9-2.43,1.9-.77,0-1.59-.19-2.16-.55l.57-1.19c.45.3,1.01.46,1.55.46s.89-.21.89-.59c0-.34-.23-.57-1.08-.57h-1.51l.28-3.26h3.55v1.22h-2.25l-.07.81h.37c1.65,0,2.29.76,2.29,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m266.14,37.05c0-.96.61-1.55,1.43-1.55s1.43.58,1.43,1.55-.61,1.55-1.43,1.55-1.43-.57-1.43-1.55Zm4.72-1.47h1.15l-3.81,5.58h-1.15l3.81-5.58Zm-2.83,1.47c0-.57-.2-.79-.47-.79-.25,0-.47.22-.47.79s.21.79.47.79c.27,0,.47-.22.47-.79Zm2.04,2.63c0-.96.6-1.54,1.43-1.54s1.43.58,1.43,1.54-.61,1.55-1.43,1.55-1.43-.57-1.43-1.55Zm1.9,0c0-.57-.21-.79-.47-.79s-.47.22-.47.79.21.79.47.79.47-.22.47-.79Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "120.41 25.25 120.41 98.93 129.33 98.93 141.6 98.93 198.82 98.93 198.82 25.25 120.41 25.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.41,25.25s.11,0,.35-.01c.25,0,.61,0,1.07-.01.96,0,2.36-.02,4.19-.03,3.69-.01,9.08-.03,15.93-.06,13.77-.03,33.39-.07,56.88-.12h.23s0,.23,0,.23c0,21.55.02,46.8.03,73.68h0v.27h-.26c-28.81-.01-55.74-.03-78.41-.04h-.22s0-.22,0-.22c.05-22.17.09-40.61.11-53.52.02-6.42.04-11.47.06-14.92.01-1.7.02-3.01.03-3.91,0-.88.02-1.33.02-1.33,0,0,.02.48.02,1.37,0,.91.01,2.23.03,3.96.01,3.47.03,8.53.06,14.97.03,12.88.07,31.28.11,53.38l-.22-.22c22.67-.01,49.6-.02,78.41-.04l-.26.26h0c.01-26.89.02-52.14.03-73.69l.23.23c-23.42-.05-43-.09-56.73-.12-6.87-.03-12.27-.05-15.98-.06-1.84-.01-3.26-.02-4.23-.03-.47,0-.83,0-1.09-.01-.25,0-.38-.01-.38-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m159.27,33.6c-13.36,0-24.19,10.83-24.19,24.19s10.83,24.19,24.19,24.19,24.19-10.83,24.19-24.19-10.83-24.19-24.19-24.19Zm.36,38.69c-8.21,0-14.86-6.65-14.86-14.86s6.65-14.86,14.86-14.86,14.86,6.65,14.86,14.86-6.65,14.86-14.86,14.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m159.64,33.61c0,2.57,0,6.05,0,8.96,8.21,0,14.86,6.65,14.86,14.86,0,1.57-.25,3.08-.7,4.51l8.77,2.38c.58-2.07.9-4.26.9-6.52,0-13.24-10.63-23.99-23.82-24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m144.77,57.43c0-6.05,3.62-11.26,8.81-13.57l-3.72-8.36c-8.69,3.67-14.78,12.27-14.78,22.3,0,.34.01.68.03,1.02h9.74c-.04-.45-.07-.91-.07-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m159.64,72.29c-1.08,0-2.13-.12-3.14-.34-.37,2.16-1.08,6.33-1.63,9.62,1.43.26,2.91.41,4.41.41,11.1,0,20.45-7.48,23.3-17.67l-8.77-2.38c-1.91,6-7.53,10.36-14.16,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m159.64,72.29c-1.08,0-2.13-.12-3.14-.34-.37,2.16-1.08,6.33-1.63,9.62,1.43.26,2.91.41,4.41.41,11.1,0,20.45-7.48,23.3-17.67l-8.77-2.38c-1.91,6-7.53,10.36-14.16,10.36Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m179.29,88.09c0,.13-8.96.23-20.02.23s-20.02-.1-20.02-.23,8.96-.23,20.02-.23,20.02.1,20.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m170.37,91.76c0,.13-4.97.23-11.1.23s-11.1-.1-11.1-.23,4.97-.23,11.1-.23,11.1.1,11.1.23Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.37,58.09c0,1.16-.97,1.9-2.19,1.9-1.56,0-2.58-.94-2.58-2.75,0-1.94,1.2-3.05,2.96-3.05.63,0,1.24.14,1.64.41l-.57,1.13c-.32-.22-.67-.29-1.03-.29-.8,0-1.33.45-1.41,1.3.31-.27.73-.41,1.26-.41,1.05,0,1.92.69,1.92,1.76Zm-1.53.07c0-.43-.31-.7-.76-.7s-.77.29-.77.71.3.7.78.7c.45,0,.76-.27.76-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.76,57.09c0-1.84,1.04-2.9,2.46-2.9s2.45,1.06,2.45,2.9-1.04,2.9-2.45,2.9-2.46-1.06-2.46-2.9Zm3.33,0c0-1.17-.37-1.61-.87-1.61s-.88.44-.88,1.61.37,1.61.88,1.61.87-.44.87-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.12,55.78c0-.96.61-1.55,1.43-1.55s1.43.58,1.43,1.55-.61,1.55-1.43,1.55-1.43-.57-1.43-1.55Zm4.72-1.47h1.15l-3.81,5.58h-1.15l3.81-5.58Zm-2.83,1.47c0-.57-.2-.79-.47-.79-.25,0-.47.22-.47.79s.21.79.47.79c.27,0,.47-.22.47-.79Zm2.04,2.63c0-.96.6-1.54,1.43-1.54s1.43.58,1.43,1.54-.61,1.55-1.43,1.55-1.43-.57-1.43-1.55Zm1.9,0c0-.57-.21-.79-.47-.79s-.47.22-.47.79.21.79.47.79.47-.22.47-.79Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 329.48,
    y: 373.49,
    width: 66.66,
    height: 9.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m396.25,382.77h-66.88v-9.39h66.88v9.39Zm-66.66-.23h66.43v-8.93h-66.43v8.93Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "335.66 379.6 345.26 426.94 380.76 426.94 390.03 382.65 335.66 379.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "335.66 422.46 340.78 429.5 383.93 429.5 390.03 422.46 335.66 422.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m360.31,380.99c-.13,0-.3-21.93-.38-48.97-.08-27.05-.03-48.98.1-48.98.13,0,.3,21.92.38,48.98.08,27.04.03,48.97-.1,48.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m375.15,326.11s-.05.18-.18.51c-.16.37-.35.84-.6,1.42-.13.31-.28.65-.43,1.02-.14.39-.29.8-.44,1.24-.16.45-.33.92-.51,1.43-.18.51-.32,1.06-.49,1.63-.73,2.27-1.31,5.06-1.86,8.16-.49,3.12-.85,6.57-1.03,10.21-.32,7.28.09,13.89.53,18.64.21,2.38.43,4.3.59,5.63.07.62.12,1.13.17,1.53.03.35.04.54.03.54-.02,0-.06-.18-.12-.53-.07-.4-.15-.9-.26-1.52-.21-1.32-.48-3.24-.74-5.62-.53-4.76-.99-11.38-.67-18.7.18-3.65.56-7.12,1.08-10.26.58-3.12,1.2-5.91,1.97-8.19.19-.57.34-1.12.53-1.63.19-.5.38-.98.55-1.42.17-.44.33-.85.48-1.24.16-.37.33-.71.47-1.01.28-.56.5-1.02.68-1.39.16-.31.25-.48.26-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m373.45,308.38s-.06.26-.21.72c-.17.51-.4,1.19-.69,2.04-.15.45-.32.94-.51,1.47-.17.55-.34,1.14-.54,1.77-.39,1.27-.84,2.71-1.24,4.33-.21.81-.44,1.65-.67,2.53-.2.89-.41,1.82-.62,2.77-.47,1.91-.8,3.98-1.23,6.15-.73,4.36-1.38,9.17-1.83,14.25-.42,5.08-.6,9.94-.67,14.36-.01,4.42.04,8.4.22,11.74.06,1.67.17,3.18.25,4.5.08,1.33.16,2.47.24,3.4.07.9.12,1.61.16,2.15.03.49.04.75.02.75-.02,0-.06-.25-.12-.74-.06-.53-.15-1.25-.25-2.14-.11-.93-.22-2.07-.33-3.4-.11-1.33-.24-2.83-.32-4.51-.22-3.34-.32-7.33-.33-11.76.04-4.43.21-9.3.63-14.39.45-5.09,1.11-9.92,1.87-14.29.44-2.17.79-4.25,1.28-6.16.23-.96.44-1.88.65-2.77.24-.88.48-1.73.7-2.53.42-1.62.9-3.06,1.31-4.33.21-.63.4-1.22.57-1.76.2-.53.38-1.02.55-1.46.33-.84.58-1.51.78-2.01.18-.46.29-.69.3-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m356.09,384.87s-.02-.09-.04-.26c-.02-.2-.04-.45-.06-.75-.05-.7-.11-1.67-.2-2.9-.16-2.56-.39-6.2-.67-10.68-.58-9.02-1.42-21.47-2.93-35.17-.78-6.85-1.67-13.35-2.61-19.25-.5-2.94-.95-5.75-1.46-8.35-.47-2.61-.97-5.03-1.44-7.24-.44-2.22-.93-4.2-1.32-5.95-.39-1.75-.76-3.25-1.07-4.48-.29-1.2-.53-2.15-.69-2.83-.07-.3-.12-.55-.17-.74-.04-.17-.05-.25-.04-.26,0,0,.04.08.09.24.06.19.13.43.21.73.19.67.45,1.61.78,2.8.34,1.22.74,2.71,1.15,4.46.42,1.75.93,3.73,1.39,5.94.49,2.21,1.01,4.63,1.5,7.24.53,2.61.99,5.41,1.5,8.35.96,5.9,1.87,12.41,2.65,19.27,1.52,13.71,2.3,26.18,2.8,35.21.24,4.51.42,8.17.52,10.69.05,1.24.08,2.21.11,2.91,0,.31.01.56.02.76,0,.17,0,.26-.01.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m359.76,293.58c-.29-3.11-3.43-5.45-6.55-5.48-3.12-.03-6.03,1.84-7.94,4.31-1.91,2.47-2.96,5.48-3.82,8.48-2.1,7.32-3.25,15.01-2.35,22.57.9,7.56,3.97,15.01,9.39,20.35.88.87,2.02,1.74,3.24,1.48.66-.14,1.2-.6,1.71-1.05,10.66-9.63,16.81-24.05,16.39-38.41-.08-2.88-.46-5.87-2.05-8.26-1.59-2.4-5.3-4.94-8.01-3.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m336.52,268.73c-1.47,2.66-2.93,5.31-4.4,7.97-.1.19-.24.39-.45.41-.23.02-.4-.2-.53-.39-3.88-5.95-7.76-11.91-11.64-17.86l2.68-1.52,14.34,11.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m336.52,268.73c-1.47,2.66-2.93,5.31-4.4,7.97-.1.19-.24.39-.45.41-.23.02-.4-.2-.53-.39-3.88-5.95-7.76-11.91-11.64-17.86l2.68-1.52,14.34,11.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m360.13,283.09c-13.23-7.81-26.46-15.61-39.69-23.42-.4-.24-.84-.52-.97-.97-.16-.59.28-1.15.71-1.59,5.46-5.63,13.39-8.9,21.21-8.33,7.82.56,15.35,5.08,19.18,11.93,3.83,6.84,3.96,15.9-.44,22.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m326.16,252.19s.18-.04.52-.06c.34-.02.85-.08,1.5-.07,1.3-.03,3.2.05,5.51.44,2.31.38,5.01,1.12,7.84,2.38,2.83,1.26,5.75,3.07,8.42,5.46,2.64,2.41,4.74,5.15,6.28,7.83,1.54,2.69,2.55,5.31,3.15,7.57.61,2.26.89,4.14.98,5.44.07.65.04.81.06,1.16,0,.34-.29.87-.31.87-.04,0,.22-.72.06-2-.15-1.29-.48-3.14-1.12-5.36-1.25-4.42-4.17-10.38-9.42-15.14-5.26-4.75-11.48-7.06-16-7.87-2.28-.42-4.15-.56-5.45-.58-1.3-.03-2.02,0-2.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m354.75,266.92c.02.06-.74.41-2.01.91-1.26.5-3.03,1.14-5.01,1.76-1.98.63-3.79,1.13-5.11,1.45-1.32.32-2.15.47-2.16.41-.02-.07.78-.33,2.07-.74,1.46-.46,3.17-.99,5.06-1.58,1.88-.61,3.58-1.16,5.04-1.63,1.29-.42,2.1-.66,2.12-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m348.5,250.13c.13-.01.41,1.97.47,4.43.06,2.46-.12,4.45-.25,4.45-.13,0-.17-1.99-.23-4.43-.06-2.44-.13-4.43,0-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.09,259.22c-.02-.06,1.08-.46,2.88-1.01,1.8-.56,4.31-1.26,7.11-1.93,2.8-.67,5.36-1.19,7.22-1.52,1.86-.33,3.02-.47,3.03-.41.01.07-1.12.33-2.96.74-1.84.41-4.38.98-7.17,1.65-2.79.67-5.31,1.32-7.13,1.8-1.82.47-2.96.76-2.97.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m343.38,286.9c-3.41-2.59-7.02-3.1-11.3-2.93-4.28.17-8.45,1.47-12.37,3.19-6.69,2.93-12.98,7.25-16.98,13.37-4,6.12-5.39,14.21-2.4,20.88.3.66.69,1.36,1.36,1.64.7.3,1.51.07,2.24-.17,7.61-2.48,15.28-4.99,22.28-8.88,7-3.89,13.37-9.29,17.13-16.37.9-1.7,1.66-3.52,1.8-5.43.15-1.92-.38-3.95-1.75-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m343.45,286.09s-.18.09-.55.22c-.41.14-.94.32-1.6.55-.35.12-.74.25-1.15.39-.42.15-.86.34-1.35.53-.96.39-2.08.78-3.26,1.35-.6.27-1.22.55-1.87.85-.65.3-1.29.67-1.98,1.01-1.38.68-2.78,1.54-4.26,2.42-2.92,1.85-6.01,4.07-9.01,6.68-2.98,2.65-5.58,5.43-7.78,8.09-1.06,1.36-2.1,2.64-2.95,3.92-.43.63-.88,1.23-1.26,1.83-.38.61-.74,1.19-1.08,1.74-.72,1.09-1.24,2.15-1.75,3.06-.25.46-.49.88-.69,1.27-.19.4-.37.76-.53,1.1-.31.62-.55,1.12-.75,1.51-.18.34-.28.52-.29.52-.02,0,.05-.2.2-.55.17-.4.39-.92.67-1.55.15-.34.31-.71.49-1.12.19-.4.42-.83.66-1.29.49-.92,1-2,1.7-3.11.34-.56.69-1.15,1.06-1.77.37-.61.81-1.22,1.24-1.86.84-1.3,1.87-2.59,2.93-3.97,2.2-2.69,4.8-5.5,7.81-8.17,3.03-2.64,6.15-4.86,9.1-6.7,1.5-.87,2.92-1.73,4.31-2.4.69-.34,1.35-.7,2-1,.66-.29,1.29-.56,1.89-.83,1.19-.55,2.32-.92,3.3-1.29.49-.18.94-.35,1.37-.49.42-.13.81-.24,1.17-.35.67-.19,1.21-.34,1.62-.46.37-.1.57-.15.57-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316.78,300.53c.04.13-3.68,1.32-8.3,2.68-4.62,1.35-8.4,2.35-8.44,2.22s3.68-1.32,8.3-2.68c4.62-1.35,8.4-2.34,8.44-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316.44,318.86c-.06,0-.14-.99-.18-2.59-.04-1.6-.05-3.81.02-6.25.07-2.44.2-4.65.33-6.24.13-1.59.26-2.58.33-2.57.07,0,.06.99,0,2.59-.05,1.75-.12,3.88-.19,6.24-.06,2.36-.11,4.49-.16,6.24-.04,1.6-.09,2.59-.15,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m332.14,310.86c-.13,0-.55-4.48-.93-10.03-.38-5.55-.59-10.06-.46-10.07.13,0,.55,4.48.93,10.04.38,5.55.59,10.06.46,10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.6,290.32c0-.07,1.02-.09,2.66-.08,1.64.01,3.91.06,6.41.14,2.5.08,4.77.18,6.4.28,1.64.1,2.65.19,2.65.26,0,.07-1.02.09-2.66.08-1.64-.01-3.91-.06-6.41-.14-2.5-.08-4.77-.18-6.41-.28-1.64-.1-2.65-.19-2.65-.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m350.2,344.84s-.04-.18-.06-.53c-.02-.4-.04-.9-.07-1.52-.06-1.32-.07-3.24-.02-5.61.04-2.37.2-5.19.49-8.31.31-3.12.76-6.54,1.39-10.11.66-3.56,1.44-6.93,2.26-9.96.83-3.03,1.68-5.73,2.47-7.97.79-2.24,1.48-4.04,2-5.26.25-.57.45-1.04.6-1.41.14-.32.22-.48.24-.48.02,0-.04.18-.15.51-.14.38-.31.85-.52,1.44-.47,1.24-1.11,3.05-1.85,5.3-.75,2.25-1.56,4.95-2.37,7.97-.78,3.03-1.56,6.38-2.21,9.93-.64,3.55-1.1,6.96-1.43,10.07-.31,3.11-.5,5.92-.59,8.28-.09,2.36-.13,4.28-.13,5.6,0,.62-.01,1.13-.02,1.52,0,.35-.02.53-.04.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m352.29,318.9s-.56.71-1.58,1.73c-1.03,1.02-2.48,2.39-4.14,3.85-1.66,1.46-3.21,2.72-4.36,3.6-1.15.88-1.89,1.39-1.93,1.34-.04-.05.62-.65,1.71-1.6,1.22-1.06,2.66-2.31,4.26-3.7,1.58-1.4,3.02-2.67,4.23-3.74,1.08-.96,1.76-1.54,1.81-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m364.83,329c-.06.04-.69-.87-1.68-2.33-1.08-1.58-2.43-3.54-3.92-5.71-1.52-2.15-2.89-4.09-4-5.66-1.03-1.45-1.65-2.35-1.6-2.39.05-.04.77.79,1.87,2.19,1.1,1.4,2.57,3.36,4.12,5.59,1.55,2.23,2.88,4.29,3.81,5.8.93,1.52,1.46,2.48,1.4,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m358.26,297.22c.07.11-4.1,2.92-9.31,6.26-5.21,3.35-9.49,5.98-9.56,5.87-.07-.11,4.1-2.91,9.31-6.27,5.21-3.35,9.49-5.98,9.56-5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m370.01,309.91c-.09.09-2.91-2.51-6.3-5.82-3.39-3.31-6.06-6.07-5.97-6.16.09-.09,2.91,2.51,6.3,5.82,3.39,3.31,6.06,6.07,5.97,6.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.96,309.65l3.58-.3c2.54-.21,5-.96,7.22-2.21,1.1-.62,2.2-1.22,3.37-1.69,4.42-1.78,9.36-1.46,14.12-1.7,7.77-.39,15.45-2.35,22.46-5.74.4-.2.76-.49.98-.89.73-1.34-.63-2.53-1.8-3.25-6.03-3.71-12.16-7.47-18.99-9.32-6.83-1.84-14.59-1.53-20.42,2.48-6.85,4.71-9.34,14.39-10.5,22.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m424.76,296.69s-.22-.08-.61-.28c-.43-.22-.99-.52-1.7-.89-1.47-.77-3.59-1.91-6.26-3.2-2.68-1.27-5.92-2.7-9.69-3.74-3.76-1.04-8.09-1.59-12.56-1.02-4.45.59-8.55,2.32-11.45,4.92-2.92,2.59-4.7,5.72-5.96,8.38-1.26,2.68-2.03,4.96-2.59,6.52-.26.75-.48,1.35-.64,1.8-.15.41-.23.63-.25.62-.02,0,.04-.23.16-.65.14-.46.32-1.07.55-1.83.51-1.58,1.24-3.88,2.47-6.6,1.23-2.7,3.01-5.89,5.98-8.56,2.96-2.68,7.15-4.47,11.68-5.06,4.55-.58,8.95-.01,12.74,1.07,3.81,1.07,7.06,2.54,9.72,3.86,2.67,1.33,4.76,2.51,6.2,3.34.69.4,1.23.72,1.65.97.37.23.57.35.56.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.17,301.3c-.07.11-4.75-2.92-10.45-6.76-5.7-3.84-10.26-7.04-10.18-7.15.07-.11,4.75,2.92,10.45,6.76,5.7,3.84,10.26,7.04,10.18,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m411.18,287.14c.02.1-1.49.46-3.41.61-1.92.16-3.48.06-3.47-.05,0-.11,1.54-.19,3.43-.35,1.89-.15,3.42-.33,3.45-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m390.7,284.47c.11.05-.57,1.13-1.53,2.4-.96,1.27-1.83,2.26-1.94,2.21s.57-1.13,1.53-2.4c.96-1.27,1.83-2.26,1.94-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m394.89,304.06c-.03.05-.9-.4-2.25-1.22-1.35-.82-3.18-2.02-5.13-3.44-1.95-1.42-3.67-2.76-4.91-3.74-1.24-.98-1.98-1.61-1.94-1.67.04-.05.86.48,2.14,1.4,1.4,1.02,3.1,2.26,4.99,3.62,1.94,1.41,3.73,2.65,5.03,3.54,1.3.89,2.11,1.44,2.07,1.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.23,324.85c-3.41-.9-7.48,2.42-8.18,5.88-.7,3.46.59,6.99,2.11,10.18,3.36,7.05,8,13.59,14.11,18.46,6.11,4.87,13.76,7.98,21.57,7.94-1.44-6.7.38-13.7-.42-20.5-.7-5.94-3.47-11.62-7.72-15.82-4.25-4.21-9.95-6.92-15.9-7.56-2.18-.24-4.7-.58-5.57,1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m407.84,367.31s-.17-.06-.49-.23c-.31-.17-.75-.44-1.28-.86-1.07-.81-2.3-2.38-3.37-4.51-.54-1.06-1.15-2.2-1.75-3.47-.58-1.27-1.19-2.63-1.84-4.06-.65-1.42-1.37-2.9-2.26-4.34-.88-1.44-1.94-2.85-3.1-4.22-2.34-2.74-4.84-5.12-7.01-7.39-2.18-2.26-4.02-4.43-5.35-6.42-1.34-1.97-2.15-3.74-2.61-4.99-.22-.63-.38-1.12-.46-1.46-.09-.34-.12-.52-.11-.52.04-.01.24.7.74,1.92.51,1.22,1.36,2.94,2.72,4.87,1.35,1.94,3.19,4.07,5.39,6.3,2.18,2.24,4.7,4.61,7.06,7.38,1.18,1.38,2.24,2.82,3.14,4.29.9,1.47,1.61,2.97,2.26,4.4.63,1.43,1.23,2.79,1.79,4.07.57,1.26,1.16,2.42,1.69,3.48,1.03,2.13,2.17,3.67,3.19,4.52,1,.86,1.67,1.18,1.64,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m390.2,361.74c-.06-.01.05-.89.31-2.3.27-1.4.71-3.33,1.3-5.44.59-2.1,1.23-3.98,1.73-5.31.51-1.34.87-2.14.93-2.12.06.02-.19.87-.61,2.23-.42,1.36-1,3.24-1.59,5.33-.59,2.09-1.08,4-1.43,5.38-.35,1.38-.57,2.24-.64,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m407.2,345.29c-.02.07-.93-.17-2.4-.55-1.47-.38-3.5-.91-5.76-1.42-2.26-.51-4.32-.9-5.81-1.19-1.49-.28-2.42-.46-2.41-.53,0-.06.95,0,2.46.2,1.51.2,3.59.54,5.86,1.06,2.27.51,4.3,1.09,5.75,1.56,1.45.47,2.33.82,2.31.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m377.54,350.07c-.06-.01.07-1.03.37-2.66.3-1.63.78-3.87,1.42-6.31.64-2.45,1.32-4.63,1.85-6.2.53-1.57.92-2.52.98-2.5.06.02-.2,1.01-.66,2.6-.45,1.59-1.08,3.78-1.71,6.22-.64,2.44-1.16,4.66-1.55,6.26-.38,1.61-.63,2.6-.7,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m399.37,330.96c-.01.13-4.27-.21-9.51-.77-5.24-.56-9.48-1.11-9.46-1.24.01-.13,4.27.21,9.51.77,5.24.56,9.48,1.11,9.46,1.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m396.25,382.61c0,.13-14.97.24-33.44.24s-33.44-.11-33.44-.24,14.97-.24,33.44-.24,33.44.11,33.44.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m385.83,401.88c0,.13-10.09.24-22.53.24s-22.53-.11-22.53-.24,10.09-.24,22.53-.24,22.53.11,22.53.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m385.44,404.64c0,.13-9.91.24-22.14.24s-22.14-.11-22.14-.24,9.91-.24,22.14-.24,22.14.11,22.14.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m386.23,399.61c0,.13-10.43.24-23.3.24s-23.31-.11-23.31-.24,10.43-.24,23.31-.24,23.3.11,23.3.24Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m70.01,376.29l-27.1,22.23,27.48,33.86c3.07-2.82-4.65-25.61-4.65-25.61l17.95-13.53-13.68-16.95Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.71,395.11c-.71-.51-1.82-.36-2.35.32-.54.69-.4,1.81.3,2.34.7.52,2.03.39,2.49-.36.46-.75.22-2.06-.58-2.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m43.01,398.43l2.73-2.26,25.19,33.57s.55,2.04-.65,2.73l-27.26-34.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m66.36,407.18c-.17.13-.92-.64-2.11-1.02-1.18-.41-2.24-.25-2.3-.46-.09-.18,1.1-.73,2.53-.25,1.44.47,2.05,1.63,1.87,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m67.77,411.92c-.13.17-.99-.32-2.15-.31-1.16-.03-2.03.44-2.15.27-.15-.13.72-1.03,2.16-1.01,1.44,0,2.29.92,2.14,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m65.16,417.39c-.16-.12.48-1.02,1.73-1.33,1.25-.32,2.24.17,2.16.35-.06.2-.95.1-1.98.37-1.03.25-1.76.76-1.91.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.1,403.64c-.21.05-.59-.89-1.42-1.77-.8-.9-1.71-1.37-1.64-1.57.04-.19,1.23.02,2.18,1.07.96,1.05,1.06,2.25.87,2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m73.47,399.57c-.07.06-.7-.51-1.37-1.7-.33-.59-.66-1.34-.9-2.22-.12-.44-.21-.9-.27-1.39-.03-.24-.08-.5-.02-.84.02-.32.38-.78.82-.79.4-.04.76.18.97.42.21.24.32.49.43.71.21.45.38.91.49,1.35.23.89.29,1.71.24,2.4-.09,1.38-.49,2.15-.57,2.12-.12-.03.09-.83.04-2.12-.02-.64-.13-1.4-.38-2.2-.13-.4-.29-.81-.49-1.22-.2-.44-.44-.74-.68-.7-.09.02-.12.03-.16.19-.03.16-.01.38.01.61.05.46.12.9.22,1.31.19.83.44,1.56.7,2.15.52,1.19.99,1.86.9,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m73.06,399.55c-.07-.04.25-.85,1.27-1.78.51-.46,1.2-.93,2.04-1.28.42-.17.89-.31,1.38-.4.5-.07,1.14-.19,1.73.39.28.33.25.82.1,1.09-.14.3-.32.48-.48.68-.34.38-.74.69-1.14.93-.81.48-1.65.67-2.34.7-1.41.05-2.17-.48-2.13-.54.04-.12.83.19,2.08.02.62-.09,1.35-.31,2.03-.76.34-.22.67-.5.95-.83.32-.35.5-.72.35-.82-.13-.17-.64-.24-1.04-.14-.44.07-.87.19-1.26.33-.78.28-1.45.67-1.96,1.05-1.03.76-1.51,1.44-1.61,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m57.73,394.45l.33,35.05,43.61-.19c-.27-4.16-22.87-12.43-22.87-12.43l.71-22.47-21.78.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.3,415.05c-.84.23-1.42,1.19-1.22,2.04.2.85,1.16,1.45,2.01,1.23.85-.22,1.58-1.34,1.28-2.16-.29-.82-1.46-1.46-2.23-1.05"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m58.05,429.36l-.05-3.54,41.94,1.42s1.94.85,1.72,2.22l-43.61-.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m79.5,416.65c0,.21-1.07.31-2.12,1-1.06.66-1.6,1.59-1.8,1.5-.2-.04.12-1.31,1.4-2.13,1.27-.82,2.56-.57,2.52-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m84.08,418.53c.05.21-.87.57-1.59,1.48-.75.88-.92,1.86-1.14,1.85-.2.03-.35-1.21.56-2.32.91-1.11,2.16-1.21,2.16-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.71,423.99c-.19.05-.49-1.02.05-2.19.53-1.17,1.54-1.64,1.63-1.46.12.17-.52.8-.95,1.77-.45.96-.51,1.85-.72,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m79.1,411.52c-.09.19-1.07-.1-2.27,0-1.21.06-2.14.47-2.25.29-.12-.15.79-.95,2.21-1.03,1.42-.09,2.42.58,2.32.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.04,406.35c0,.09-.84.22-2.18,0-.67-.11-1.46-.33-2.29-.69-.41-.18-.84-.4-1.26-.66-.2-.13-.44-.26-.66-.51-.24-.22-.37-.79-.1-1.13.22-.34.62-.48.93-.49.32-.01.58.05.82.11.49.12.94.27,1.36.46.83.38,1.51.85,2.02,1.31,1.02.93,1.36,1.73,1.29,1.77-.1.07-.59-.59-1.62-1.36-.52-.38-1.17-.78-1.95-1.09-.39-.15-.81-.29-1.26-.38-.46-.12-.86-.12-.97.08-.04.08-.05.11.05.24.1.12.29.25.49.37.39.25.78.47,1.16.65.76.37,1.49.63,2.11.8,1.25.34,2.07.4,2.07.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m77.76,406.65c-.08.03-.5-.73-.58-2.11-.04-.68.03-1.51.29-2.39.13-.44.31-.89.55-1.33.25-.43.56-1.01,1.39-1.11.43-.02.79.32.92.61.15.29.18.55.23.8.08.51.07,1.01,0,1.47-.13.93-.51,1.7-.92,2.26-.85,1.13-1.74,1.39-1.75,1.32-.07-.11.67-.52,1.32-1.61.32-.54.6-1.24.68-2.06.04-.4.03-.83-.05-1.26-.07-.46-.25-.84-.42-.79-.22,0-.58.35-.76.72-.22.39-.4.79-.54,1.19-.27.79-.39,1.54-.41,2.18-.05,1.28.18,2.08.06,2.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.46,191.4s-6.11,6.54-9.11,12.81-4.92,21.23-4.92,21.23c0,0-8.44,18.8-7.16,28.42,1.28,9.62,9.88,75.39,9.88,75.39,0,0-.42,63.94,5.66,75.34l1.36,6.15,24.59-4.36h0l-.15-3.69,5.81-125.38,14.79-85.35-40.74-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m115.72,210.04s14.7,80.93,16,94.98c1.3,14.05-48.74,88.11-48.74,88.11l-22.88-23.83,32.84-61.04-10.67-61.52,14.85-54.35,15.59.55,3.02,17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m52,384.69s.01.62.18,1.79c.15,1.17.44,2.9.85,5.12.82,4.45,2.14,10.91,3.92,18.98l.04.17.17-.03c6.95-1.22,15.29-2.68,24.59-4.31l.19-.03v-.19c.69-16.87,1.51-37.04,2.38-58.67.91-23.27,1.75-44.85,2.44-62.56v.02c1.84-14.22,3.37-25.98,4.43-34.21.51-4.09.92-7.3,1.2-9.51.13-1.08.23-1.91.3-2.5.06-.57.08-.86.08-.86,0,0-.06.29-.15.85-.09.59-.21,1.42-.36,2.49-.31,2.21-.75,5.41-1.32,9.49-1.11,8.22-2.7,19.98-4.63,34.19h0s0,.02,0,.02c-.72,17.7-1.59,39.28-2.54,62.55-.84,21.63-1.63,41.8-2.29,58.68l.19-.22c-9.3,1.67-17.63,3.17-24.58,4.42l.21.14c-1.83-8.05-3.21-14.5-4.08-18.94-.44-2.22-.76-3.94-.94-5.1-.1-.58-.16-1.03-.2-1.33-.04-.3-.08-.45-.08-.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.05,54.9c.74-4.29-2.54-8.61-6.69-9.92-4.15-1.3-8.79-.03-12.36,2.46-2.66,1.85-4.86,4.34-7.67,5.95-2.56,1.46-5.51,2.13-8.04,3.65-3.95,2.37-6.54,6.85-6.63,11.46-.06,3.2.96,6.61-.47,9.48-1.56,3.12-5.49,4.4-7.27,7.39-1.61,2.71-1.08,6.15-.31,9.22.77,3.06,1.73,6.28.84,9.31-.81,2.76-3.03,4.87-4.27,7.46-2.46,5.16-.22,12.06,4.81,14.78l26.41-10.72,21.67-60.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.36,53.21c4.07-.39,7.76,2.84,9.34,6.61,1.58,3.77,1.53,7.99,1.59,12.07.06,4.09.3,8.35,2.34,11.89,1.07,1.86,2.58,3.42,3.81,5.18,1.23,1.76,2.19,3.86,1.92,5.99-.5,3.87-4.74,6.25-5.81,10-.87,3.04.53,6.34-.17,9.42-.54,2.37-2.28,4.33-4.34,5.64-2.05,1.3-4.41,2.03-6.75,2.7l-13.25-10.26,3.22-60.09,8.11.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m67.25,73.63l1.58,42.63c.27,7.25,6.55,12.8,13.78,12.17h0c6.74-.58,11.45-6.28,11.19-13.04-.12-3.21-.05-7.01-.04-7.34,0,0,10.68-2.4,11.07-13.17.19-5.2.06-13.95-.49-23.67-.6-10.44-9.12-18.67-19.58-18.91l-1.04-.02c-11.22.39-17.16,10.14-16.46,21.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m93.8,108.11s-6.82.39-13.95-4.32c0,0,3.14,7.83,13.91,7.11l.04-2.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m101.75,80.77c0,.81-.67,1.49-1.52,1.52-.85.03-1.54-.61-1.55-1.42,0-.81.67-1.49,1.52-1.52.85-.03,1.55.61,1.56,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m101.97,77.14c-.2.2-1.34-.69-3-.73-1.65-.06-2.89.77-3.06.56-.09-.09.12-.45.65-.82.53-.37,1.43-.72,2.46-.7,1.03.03,1.89.43,2.38.83.5.4.66.77.57.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.05,80.77c0,.81-.67,1.49-1.52,1.52-.85.03-1.54-.61-1.55-1.42,0-.81.67-1.49,1.52-1.52.85-.03,1.55.61,1.55,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.14,77.37c-.2.2-1.34-.69-3-.73-1.65-.06-2.89.76-3.06.56-.09-.09.11-.45.66-.82.53-.37,1.43-.72,2.46-.7,1.03.03,1.89.43,2.38.83.5.4.66.77.57.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m91.33,88.79c0-.09,1.03-.25,2.7-.42.42-.03.83-.11.9-.4.11-.3-.06-.76-.25-1.26-.37-1.03-.76-2.11-1.17-3.25-1.63-4.62-2.8-8.42-2.61-8.49.19-.06,1.66,3.63,3.29,8.26.39,1.14.77,2.23,1.12,3.27.15.48.41,1.04.18,1.66-.12.31-.44.54-.71.6-.27.08-.51.08-.72.08-1.68.05-2.72.03-2.73-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m85.63,70.87c-.19.44-1.83.15-3.78.28-1.96.1-3.55.59-3.79.17-.11-.2.19-.61.84-1.01.6-.35,1.16-.75,3-.75,1.17-.07,2.07.09,2.76.41.7.32,1.04.69.96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.62,70.81c-.34.37-1.68-.03-3.28-.07-1.6-.08-2.97.22-3.27-.18-.13-.19.08-.57.68-.92.59-.35,1.57-.63,2.67-.59,1.1.04,2.05.39,2.61.78.56.39.74.78.59.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m91.85,94.09c-.08-.33-.17-.66-.34-.96-.37-.67-1.12-1.1-1.89-1.15-.77-.05-1.54.25-2.12.75-.55.5-.82,1.07-.83,1.77,0,.18.06.36.13.52.4.92,1.23,1.66,2.22,1.85.98.19,2.08-.22,2.63-1.05.16-.24.28-.52.31-.81.03-.31-.03-.62-.11-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m68.93,88c-.07-.02-.14.04-.13.11,0,.07.1.11.16.07.06-.04.05-.14,0-.17-.03-.02-.07-.02-.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m69.09,87.54c-.07-.02-.14.04-.13.11,0,.07.1.11.16.07.06-.04.05-.14,0-.17-.03-.02-.07-.02-.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m93.27,94.83c.02.13-.42.37-1.22.49-.78.12-1.97.12-3.14-.46-1.18-.56-1.9-1.57-2.23-2.29-.34-.74-.35-1.25-.23-1.3.29-.15,1.02,1.72,2.91,2.66.93.47,1.93.58,2.66.66.73.07,1.22.09,1.24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.21,82.97c-2.47-8.69-1.21-18.63,4.34-25.76,5.55-7.13,15.61-10.8,24.15-7.86,1.21.42,2.4.97,3.28,1.9.88.93,1.38,2.29,1.02,3.51-.57,1.92-2.9,2.69-4.9,2.78-2.01.09-4.16-.16-5.89.85-3.06,1.79-2.99,6.3-5.16,9.1-1.07,1.38-2.66,2.3-3.63,3.75-2.62,3.92-.45,6.28-2.13,10.68-.47,1.22-2.59,2.34-3.89,2.51-1.3.18-.26.16-3.03-.14h0l-4.15-1.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m71.05,84.45c-.18-.09-7.23-2.56-7.38,4.76-.15,7.32,7.23,5.96,7.25,5.75.02-.21.13-10.51.13-10.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m68.74,92.14s-.13.09-.35.18c-.21.09-.57.15-.95,0-.77-.3-1.39-1.54-1.4-2.86,0-.67.15-1.3.39-1.82.23-.53.59-.9.98-.96.39-.08.66.16.75.36.09.21.04.35.08.37.02.02.16-.12.11-.42-.03-.15-.11-.32-.28-.46-.17-.15-.43-.22-.7-.2-.57.03-1.08.54-1.35,1.11-.3.57-.49,1.28-.48,2.03.02,1.48.74,2.87,1.8,3.2.51.14.94,0,1.17-.17.23-.18.27-.34.25-.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m54.89,70.15c.03-.12,1.77,1.02,4.94,1.11,1.56.04,3.44-.19,5.41-.85,1.97-.65,4-1.74,5.99-3.08,1.99-1.35,3.78-2.8,5.43-4.11,1.64-1.31,3.16-2.46,4.49-3.34,1.33-.88,2.46-1.51,3.27-1.89.81-.38,1.27-.54,1.29-.52.02.04-.42.26-1.19.69-.77.43-1.86,1.1-3.15,2.02-1.29.92-2.77,2.09-4.39,3.41-1.63,1.32-3.42,2.8-5.44,4.17-2.02,1.36-4.1,2.46-6.14,3.11-2.03.65-3.97.85-5.57.76-1.61-.1-2.88-.46-3.7-.81-.41-.18-.72-.33-.92-.46-.2-.12-.31-.19-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m54.32,70.84c.05-.07,1.05.53,2.75,1.33,1.7.8,4.14,1.72,6.94,2.31,2.81.58,5.41.7,7.29.65,1.88-.05,3.04-.2,3.05-.12,0,.04-.28.11-.8.21-.52.11-1.29.21-2.24.28-1.9.15-4.56.08-7.41-.51-2.85-.6-5.32-1.6-7-2.49-.84-.44-1.5-.84-1.94-1.15-.44-.3-.67-.48-.65-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m107.09,66.42c-.01.13-1.76-.19-3.38-1.57-1.63-1.37-2.24-3.04-2.11-3.08.14-.07.91,1.4,2.45,2.68,1.52,1.3,3.1,1.82,3.05,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m106.8,73.52c.09.11-.31.55-.98.78-.67.23-1.25.13-1.25,0,0-.15.5-.28,1.08-.48.58-.2,1.06-.4,1.15-.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m147.69,162.34s-.17-3.76,1.74-6.36c1.91-2.6,5.98-3.79,6.33-5.6.35-1.81,3.46-5.44,4.96-4.6,1.5.84,2.18,2.8-.04,5.06-2.21,2.26-3.88,4.79-3.88,4.79,0,0,19.44-3.36,20.86-3.12,1.42.25,2.84.49,2.85,1.69s-3.76,1.53-3.76,1.53l-6.33,4.4s-2.36,3.29-5.11,5.28c-2.75,1.99-7.1,2.52-7.1,2.52l-6.73,4.3s-6.57-4.87-3.79-9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m176.39,155.87s-.12-.15-.34-.35c-.22-.2-.6-.45-1.14-.52-1.07-.14-2.64.32-4.08,1.21-1.46.9-2.57,2.03-3.38,2.83-.8.81-1.31,1.32-1.36,1.27-.05-.04.36-.62,1.11-1.5.75-.87,1.85-2.07,3.38-3.01,1.53-.93,3.18-1.38,4.39-1.13.61.13,1.02.46,1.22.73.2.28.22.47.2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m169.58,156.1c.03.13-1.28.52-2.92.87-1.64.35-3,.53-3.02.4s1.28-.52,2.92-.87c1.64-.35,3-.53,3.02-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m159.55,157.03c-.02-.12,1.44-.15,2.81.87,1.39,1.01,1.8,2.4,1.67,2.42-.13.06-.69-1.12-1.96-2.03-1.25-.93-2.55-1.11-2.53-1.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.19,119.22s9.54,4.85,11.87,11.26c1.22,3.36,8.45,39.19,8.45,39.19l14.53-9.88,9.84,14.8-23.25,18.1c-4.55,1.14-9.36.85-13.67-.98-1.58-.67-2.85-1.45-3.16-2.28-.94-2.58-4.61-70.21-4.61-70.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.34,175.58c-1.59,2.41-2.34,5.56-1.22,8.22.1.24.22.48.43.62.46.32,1.13.02,1.42-.45.29-.48.31-1.06.34-1.62.26-4.63,2.14-9.16,5.24-12.61v-.14c-2.29,1.75-4.62,3.56-6.21,5.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.71,123.99l27.59-8.95c5.36,14.25,22.62,11.82,23.5.35l16.39,3.94s5.48,34.79,4.15,42.02c-2.14,11.63,3.23,49.38,6.08,62.95,2.47,11.76-4.74,18.75-8.36,21.95-18.42,16.28-27.99,14.09-41.47,5.64-13.7-8.59-29.77-14.65-29.77-14.65,1.34-15.75,10.06-32.09,15.68-43.91h0l-2.56-27.47-11.23-41.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m119.94,220.17s-.1-.27-.23-.81c-.13-.53-.33-1.32-.56-2.33-.47-2.03-1.09-4.99-1.73-8.66-.64-3.67-1.25-8.08-1.71-12.99-.46-4.91-.73-10.33-.81-16.02-.08-5.69-.17-11.1-.54-16-.35-4.9-.98-9.3-1.82-12.92-.83-3.62-1.79-6.48-2.59-8.4-.36-.98-.74-1.69-.94-2.2-.22-.5-.32-.77-.31-.78.02,0,.15.24.4.73.23.5.64,1.2,1.03,2.17.86,1.9,1.88,4.76,2.76,8.39.89,3.63,1.56,8.04,1.94,12.96.4,4.92.5,10.35.58,16.03.08,5.68.34,11.08.77,15.98.43,4.9,1.01,9.3,1.6,12.97.59,3.68,1.15,6.64,1.56,8.68.19.99.35,1.77.46,2.35.1.54.15.82.13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.71,124.07c-.87.44-4.91,2.93-6.99,7.94-1.88,4.54-7,65.76-6.13,69.68s4.96,9.8,11.76,12.85c5.71,2.56,20.48-3.66,26.46-5.86.19-.07-1.34-2.37-1.95-3.9l-5.13-16.15-8.12.88,3.02-30.37-12.92-35.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m51.73,144.66s.18.6.42,1.7c.21,1.11.48,2.72.73,4.72.52,4,1,9.55,1.45,15.67.43,6.09.82,11.6,1.11,15.69.16,1.94.3,3.54.4,4.75.11,1.12.16,1.74.12,1.75-.04,0-.15-.61-.32-1.72-.16-1.12-.36-2.73-.56-4.74-.41-4.01-.82-9.56-1.26-15.69-.45-6.13-.87-11.67-1.3-15.67-.21-2-.42-3.61-.57-4.73-.17-1.11-.25-1.73-.22-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m62.03,188.03c0,.06-.97.26-2.64.55s-4.03.68-6.8,1.12h-.07s-.07-.02-.07-.02c-1.34-.61-2.93-1.02-4.61-1.1-1.95-.08-3.82.28-5.38.95-1.57.66-2.82,1.57-3.77,2.45-1.88,1.78-2.53,3.32-2.62,3.26-.02-.01.11-.4.47-1.04.36-.64.97-1.53,1.9-2.48.94-.93,2.21-1.91,3.83-2.62,1.61-.72,3.56-1.12,5.59-1.03,1.75.08,3.4.52,4.79,1.17l-.14-.02c2.77-.4,5.14-.72,6.83-.93,1.68-.21,2.68-.31,2.68-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m66.02,204.83s.24.32.61.96c.41.73.92,1.65,1.53,2.74l.1.17-.19.07c-2.76,1.07-6.83,2.61-11.37,4.28-1.36.5-2.68.98-3.92,1.43l-.15-.48h.02s.01,0,.01,0h0s0,0,0,0h0s0,0,0,0l.12.49h0s-.05.01-.05.01h-.02s-.01,0-.01,0h0s0,0,0,0h0s0,0,0,0l-.12-.49h0s0,0,0,0h.05s.14.47.14.47c-3.36,1.13-6.5,1.11-8.62.77-1.07-.16-1.9-.37-2.47-.54-.56-.17-.86-.29-.85-.32.02-.08,1.25.3,3.36.54,2.1.25,5.16.2,8.42-.93l.14.48h-.05s0,.01,0,.01h0l-.12-.49h0s0,0,0,0h0s0,0,0,0h.01s.02,0,.02,0h.05s0-.01,0-.01h0l.12.49h0s0,0,0,0h0s0,0,0,0h-.01s-.02,0-.02,0l-.15-.48c1.24-.46,2.55-.95,3.91-1.45,4.54-1.67,8.63-3.14,11.43-4.12l-.09.24c-.56-1.13-1.02-2.07-1.39-2.82-.31-.66-.47-1.03-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.73,169.5c.11.12-1.51,1.47-2.8,3.66-1.29,2.18-1.77,4.23-1.94,4.19-.12-.01.15-2.17,1.49-4.45,1.35-2.29,3.19-3.5,3.24-3.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.96,58.14c0,.07,0,.14,0,.21,0,0,0,0,0,0v-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m77.08,201.96c-.15.04-.85-2.21-1.23-5.09-.38-2.88-.29-5.23-.13-5.23.17,0,.34,2.32.72,5.15.37,2.84.81,5.12.64,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m67.43,94.94l-24.54,25.19c3.23,5.23,3.41,12.19.47,17.58,6.83.22,13.66.44,20.49.66.04-1.84.08-3.68.12-5.53.54,2.22,2.59,4.18,4.89,4.83,3.11.89,6.43.06,9.55-.81-5.22-13.5-8.91-27.6-10.98-41.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m72.92,147.71c0,.73-.15,45.6-.15,45.6l38.03,1.26,1.9-45.38-39.78-1.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m76.81,144.36c0,.92-5.27,54.61-5.27,54.61l41.26-.99,6.94-53.63h-42.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m114.31,155.19c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m113.92,158.72c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m113.21,163.2c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m112.46,167.2c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m112.46,171.21c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m112.09,175.41c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m111.71,179.61c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m111.33,183.82c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.95,188.02c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.58,192.22c0,.14-7.07.26-15.79.26s-15.8-.12-15.8-.26,7.07-.26,15.8-.26,15.79.12,15.79.26Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m59.63,193.22s3.28-7.25,3.97-7.66c.68-.41,12.44-1.75,14.78-1.78,2.53-.03,6.43.07,7.08,1.31.48.91.04,2.25-1.88,2.52,0,0,2.62-.14,2.34,1.51-.28,1.64-6.17,4.65-6.17,4.65,0,0,1.09,1.23-1.09,3.56l-.96,1.23s.41,2.19-.82,3.15-9.06,3.69-9.06,3.69l-2.98-.95-1.92.95s-6.24-6.07-3.28-12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m84.51,187.29c.02.07-.98.43-2.62.93-1.64.5-3.94,1.11-6.49,1.68-2.56.57-4.9.97-6.6,1.22-1.7.24-2.76.33-2.77.26-.01-.07,1.03-.29,2.71-.62,1.68-.33,4-.8,6.55-1.36,2.55-.56,4.85-1.12,6.51-1.53,1.66-.41,2.7-.65,2.72-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m79.52,193.99c.05.12-2.35,1.19-5.49,1.86-3.15.69-5.77.71-5.77.58-.01-.15,2.56-.41,5.66-1.09,3.1-.67,5.55-1.5,5.6-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m77.58,198.5c.08.11-1.42,1.24-3.6,1.94-2.18.71-4.06.67-4.05.54-.01-.15,1.79-.35,3.89-1.04,2.11-.67,3.68-1.58,3.76-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m65.83,201.32c0,.05-.61.08-1.37-.46-.37-.27-.76-.68-1.03-1.24-.29-.54-.36-1.31-.28-1.94.02-.32,0-.59-.13-.8-.13-.22-.35-.41-.55-.64-.43-.47-.62-1.02-.68-1.48-.11-.94.25-1.46.29-1.42.08.02-.12.55.07,1.36.1.39.3.85.67,1.22.19.19.44.39.64.71.21.33.23.74.22,1.08-.2,1.31.4,2.33,1.03,2.88.62.56,1.17.66,1.14.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m67.81,204.61c0,.15-.87.12-1.49-.65-.63-.77-.47-1.63-.33-1.59.15,0,.23.67.73,1.27.48.61,1.11.83,1.09.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageBanner3);
export default __webpack_public_path__ + "static/media/HomepageBanner3.02eefbda42a87e39779c731816dfd9b5.svg";
export { ForwardRef as ReactComponent };